

const flags = {  };

export function getFlag(language) {
  return "data:image/svg+xml," + encodeURIComponent(flags[language]);
}
